export default {
  403: {
    title: '页面无权限',
    description: '请联系管理员',
  },
};
